var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsFolderPlus = function SvgIconsFolderPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.273 3c.304 0 .588.15.756.4l1.548 2.3h7.696c1.452 0 2.64 1.124 2.722 2.541L22 8.4v9.9c0 1.491-1.221 2.7-2.727 2.7H4.727C3.221 21 2 19.791 2 18.3V5.7C2 4.209 3.221 3 4.727 3zm-.488 1.8H4.727a.905.905 0 0 0-.909.9v12.6c0 .497.407.9.91.9h14.545c.502 0 .909-.403.909-.9V8.4c0-.497-.407-.9-.91-.9h-8.181a.912.912 0 0 1-.757-.4L8.785 4.8zM12 10.2c.466 0 .85.347.903.795l.006.105v1.799l1.818.001c.502 0 .91.403.91.9 0 .462-.352.842-.804.894l-.106.006H12.91v1.8c0 .497-.407.9-.909.9a.906.906 0 0 1-.903-.795l-.006-.105-.001-1.8H9.273a.905.905 0 0 1-.91-.9c0-.462.352-.842.804-.894l.106-.006 1.817-.001V11.1c0-.497.408-.9.91-.9z",
    fill: "#25253A",
    fillRule: "nonzero"
  }))));
};
export default SvgIconsFolderPlus;